import { useAccessStore } from "@/stores/accessStore";

export function isPlanUnavailableError(error) {
  const status = error?.response?.status;
  const message = String(error?.response?.data?.message || "").toLowerCase();

  return status === 403 && message.includes("not available on the current plan");
}

export async function ensurePlanAccessLoaded() {
  const access = useAccessStore();
  await access.ensureAccess();
  return access;
}

export function canUsePlanModule(moduleKey) {
  if (!moduleKey) return true;
  return useAccessStore().hasModule(moduleKey);
}

export async function loadIfModule(moduleKey, loader) {
  return loadIfAnyModule([moduleKey], loader);
}

/**
 * Run a loader when any of the module keys is on the active plan.
 */
export async function loadIfAnyModule(moduleKeys, loader) {
  await ensurePlanAccessLoaded();

  const access = useAccessStore();
  const allowed = moduleKeys.some((key) => access.hasModule(key));

  if (!allowed) {
    return null;
  }

  return loader();
}

/** Returns true when the module is on the active plan (loads access if needed). */
export async function guardPlanModule(moduleKey) {
  if (!moduleKey) {
    return true;
  }

  const access = await ensurePlanAccessLoaded();
  return access.hasModule(moduleKey);
}

export const EMPTY_PAGINATED_RESPONSE = {
  data: { data: [], total: 0, per_page: 25, current_page: 1, last_page: 1 },
};
